import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import "./Navigation.scss"

export interface INavigationProps {
    onMinus: () => void;
    onPlus: () => void;

}

export class Navigation extends React.Component<INavigationProps, any> {
    render() {
        return (<div className="navigation">
            <div className="navigationItem" onClick={() => this.props.onPlus()}>
                <FontAwesomeIcon icon={faPlus} />
            </div>
            <div className="navigationItem" onClick={() => this.props.onMinus()}>
                <FontAwesomeIcon icon={faMinus} />
            </div>
        </div>)
    }
}

export default Navigation;